import { render, staticRenderFns } from "./addKeyword.vue?vue&type=template&id=664fa782&scoped=true&"
import script from "./addKeyword.vue?vue&type=script&lang=js&"
export * from "./addKeyword.vue?vue&type=script&lang=js&"
import style0 from "./addKeyword.vue?vue&type=style&index=0&id=664fa782&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664fa782",
  null
  
)

export default component.exports